import {Link} from 'react-router-dom';
import {config} from '../../config';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white">
            {/* Top Section */}
            <div className="bg-gradient-to-r from-blue-700 to-blue-900 py-8">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col md:flex-row items-center justify-between">
                        <div className="mb-6 md:mb-0">
                            <h2 className="text-2xl font-bold mb-2">Download Our Mobile App</h2>
                            <p className="text-blue-100">Book tickets on the go with exclusive app-only offers!</p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <a href="#" className="flex items-center justify-center bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition-colors">
                                <i className="fab fa-apple text-2xl mr-3"></i>
                                <div className="text-left">
                                    <div className="text-xs">Download on the</div>
                                    <div className="font-bold">App Store</div>
                                </div>
                            </a>
                            <a href="#" className="flex items-center justify-center bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition-colors">
                                <i className="fab fa-google-play text-2xl mr-3"></i>
                                <div className="text-left">
                                    <div className="text-xs">Get it on</div>
                                    <div className="font-bold">Google Play</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand Column */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center space-x-3 mb-6">
                            <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                                <i className="fas fa-bus text-white text-2xl"></i>
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold text-white">Bus<span className="text-orange-500">Express</span>
                                </h1>
                                <p className="text-blue-200">Travel Smarter, Travel Better</p>
                            </div>
                        </div>
                        <p className="text-gray-300 mb-6">
                            India's leading online bus booking platform offering safe, secure, and comfortable bus journeys across 5000+ routes.
                        </p>

                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 pb-2 border-b border-blue-800">Quick Links</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                                    <i className="fas fa-home mr-2 text-sm"></i>
                                    Home
                                </Link>
                            </li>

                            <li>
                                <Link to="/my-bookings" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                                    <i className="fas fa-calendar-check mr-2 text-sm"></i>
                                    My Bookings
                                </Link>
                            </li>

                        </ul>
                    </div>

                    {/* Information */}
                    <div>
                        <h3 className="text-xl font-bold mb-6 pb-2 border-b border-blue-800">Information</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/about-us" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                                    <i className="fas fa-info-circle mr-2 text-sm"></i>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                                    <i className="fas fa-phone-alt mr-2 text-sm"></i>
                                    Contact Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy-policy" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                                    <i className="fas fa-shield-alt mr-2 text-sm"></i>
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms-conditions" className="text-gray-300 hover:text-orange-400 transition-colors flex items-center">
                                    <i className="fas fa-file-contract mr-2 text-sm"></i>
                                    Terms & Conditions
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */} </div>
            </div>


            {/* Bottom Bar */}
            <div className="border-t border-gray-800">
                <div className="container mx-auto px-4 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="mb-4 md:mb-0">
                            <p className="text-gray-400 text-sm">
                                © {
                                new Date().getFullYear()
                            }
                                &nbsp; {
                                config.appName
                            }. All rights reserved.
                            </p>
                        </div>

                        <div className="flex items-center space-x-6">
                            <div className="flex items-center space-x-2">
                                <span className="text-gray-400 text-sm">Secure Payment:</span>
                                <div className="flex space-x-2">
                                    <i className="fab fa-cc-visa text-2xl text-gray-300"></i>
                                    <i className="fab fa-cc-mastercard text-2xl text-gray-300"></i>
                                    <i className="fab fa-cc-amex text-2xl text-gray-300"></i>
                                    <i className="fab fa-cc-paypal text-2xl text-gray-300"></i>
                                    <i className="fab fa-google-pay text-2xl text-gray-300"></i>
                                    <i className="fas fa-rupee-sign text-2xl text-gray-300"></i>
                                    <i className="fab fa-cc-discover text-2xl text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
